import React from 'react'
import { productLandingSetting } from './constants'

const ProductLanding = ({ productName }) => {
  return <>{productLandingSetting[productName].views.map(v => v)}</>
}

export default ProductLanding
